<template>
  <div class="page-layout-gallery">
    <div class="container">
      <p class="title">
        Dynamic Gallery.
      </p>
      <p class="subtitle" style="margin-top:15px;margin-bottom:30px;">
        Creating a customized dynamic grid system using Vue + Bulma's flex tile layout. <br />
        Inspiration from simplex-d site by utilizing pagejoint.com's layout engine &amp; reverse engineered <i class="material-icons color-orange">favorite</i> the CSS layout.<br />
        Click button below to see the difference!<br /><br />
        <a class="button is-white" @click="refresh()">Refresh</a>
      </p>
    </div>

    <div class="container gallery-container" style="margin-bottom:50px;">
      <div v-for="(segment, segmentIndex) in segments" class="tile is-ancestor">

        <div v-if="segment.selection === 0" class="tile is-parent tx_type_0">
          <div v-for="image in segment.images"
            class="tile is-child tx_full_h tx_full_h1">

            <a :href="image.image.path" target="_blank">
              <div
                class="tile-image"
                :style="{ 'background-image': 'url('+ image.image_900 +')' }">
              </div>
            </a>
          </div>
        </div>

        <div v-else-if="segment.selection === 1 || segment.selection === 2" class="tile is-parent tx_type_1-2">
          <div v-for="(image, index) in segment.images"
            class="tile is-child tx_full_h"
            :class="{
              'is-4 tx_full_h1': (segment.selection === 1 && index == 0) || (segment.selection === 2 && index == 1),
              'is-8 tx_full_h3': (segment.selection === 1 && index == 1) || (segment.selection === 2 && index == 0) }">

            <a :href="image.image.path" target="_blank">
              <div
                class="tile-image"
                :style="{ 'background-image': 'url('+ image.image_900 +')' }">
              </div>
            </a>
          </div>
        </div>

        <div v-else-if="segment.selection === 3 || segment.selection === 5" class="tile is-parent tx_type_3or5">
          <div v-for="image in [segment.images[0]]"
            class="tile is-child tx_full_h"
            :class="{ 'is-4 tx_full_h2': segment.selection === 3, 'is-8 tx_full_h1': segment.selection === 5 }">

            <a :href="image.image.path" target="_blank">
              <div
                class="tile-image"
                :style="{ 'background-image': 'url('+ image.image_1280 +')' }">
              </div>
            </a>
          </div>
          <div class="tile is-vertical"
            :class="{ 'is-4': segment.selection === 5, 'is-8': segment.selection === 3 }">
            <div v-for="image in [segment.images[1]]"
              class="tile is-child tx_full_h tx_full_h3">

              <a :href="image.image.path" target="_blank">
                <div
                  class="tile-image"
                  :style="{ 'background-image': 'url('+ image.image_900 +')' }">
                </div>
              </a>
            </div>
            <div v-for="image in [segment.images[2]]"
              class="tile is-child tx_full_h tx_full_h3">

              <a :href="image.image.path" target="_blank">
                <div
                  class="tile-image"
                  :style="{ 'background-image': 'url('+ image.image_900 +')' }">
                </div>
              </a>
            </div>
          </div>
        </div>

        <div v-else-if="segment.selection === 4 || segment.selection === 6" class="tile is-parent tx_type_4or6">
          <div class="tile is-vertical"
            :class="{ 'is-8': segment.selection === 4, 'is-4': segment.selection === 6 }">
            <div v-for="image in [segment.images[0]]"
              class="tile is-child tx_full_h tx_full_h3">

              <a :href="image.image.path" target="_blank">
                <div
                  class="tile-image"
                  :style="{ 'background-image': 'url('+ image.image_900 +')' }">
                </div>
              </a>
            </div>
            <div v-for="image in [segment.images[1]]"
              class="tile is-child tx_full_h tx_full_h3">

              <a :href="image.image.path" target="_blank">
                <div
                  class="tile-image"
                  :style="{ 'background-image': 'url('+ image.image_900 +')' }">
                </div>
              </a>
            </div>
          </div>
          <div v-for="image in [segment.images[2]]"
            class="tile is-child tx_full_h"
            :class="{ 'is-8 tx_full_h1': segment.selection === 6, 'is-4 tx_full_h2': segment.selection === 4 }">

            <a :href="image.image.path" target="_blank">
              <div
                class="tile-image"
                :style="{ 'background-image': 'url('+ image.image_1280 +')' }">
              </div>
            </a>
          </div>
        </div>

        <!-- // 410: __| or ..|  7 // 8
             //      ..|    __|
             //   or |__ or |..  9 // 10
             //      |..    |__  -->
        <div v-else-if="segment.selection >= 7 && segment.selection <= 10" class="tile is-parent tx_type_7to10">
          <div
            v-if="segment.selection === 9 || segment.selection === 10"
            v-for="image in [segment.images[3]]"
            class="tile is-child is-4 tx_full_h tx_full_h2">

            <a :href="image.image.path" target="_blank">
              <div
                class="tile-image"
                :style="{ 'background-image': 'url('+ image.image_1280 +')' }">
              </div>
            </a>
          </div>
          <div class="tile is-vertical is-8">
            <div
              v-if="segment.selection === 7 || segment.selection === 9"
              v-for="image in [segment.images[0]]"
              class="tile is-child tx_full_h tx_full_h3">

              <a :href="image.image.path" target="_blank">
                <div
                  class="tile-image"
                  :style="{ 'background-image': 'url('+ image.image_900 +')' }">
                </div>
              </a>
            </div>
            <div class="tile is-parent">
              <div
                v-for="image in [segment.images[1]]"
                class="tile is-child is-6 tx_full_h tx_full_h1">

                <a :href="image.image.path" target="_blank">
                  <div
                    class="tile-image"
                    :style="{ 'background-image': 'url('+ image.image_900 +')' }">
                  </div>
                </a>
              </div>
              <div
                v-for="image in [segment.images[2]]"
                class="tile is-child is-6 tx_full_h tx_full_h1">

                <a :href="image.image.path" target="_blank">
                  <div
                    class="tile-image"
                    :style="{ 'background-image': 'url('+ image.image_900 +')' }">
                  </div>
                </a>
              </div>
            </div>
            <div
              v-if="segment.selection === 8 || segment.selection === 10"
              v-for="image in [segment.images[0]]"
              class="tile is-child tx_full_h tx_full_h3">

              <a :href="image.image.path" target="_blank">
                <div
                  class="tile-image"
                  :style="{ 'background-image': 'url('+ image.image_900 +')' }">
                </div>
              </a>
            </div>
          </div>
          <div
            v-if="segment.selection === 7 || segment.selection === 8"
            v-for="image in [segment.images[3]]"
            class="tile is-child is-4 tx_full_h tx_full_h2">

            <a :href="image.image.path" target="_blank">
              <div
                class="tile-image"
                :style="{ 'background-image': 'url('+ image.image_1280 +')' }">
              </div>
            </a>
          </div>
        </div>

        <!-- // 510: ..| or |..  11 // 12   or .|.  // 13
             //      ..|    |..                .|. -->
        <div v-else-if="segment.selection >= 11 && segment.selection <= 13" class="tile is-parent tx_type_11to13">
          <div
            v-if="segment.selection === 12"
            v-for="image in [segment.images[4]]"
            class="tile is-child is-4 tx_full_h tx_full_h2">

            <a :href="image.image.path" target="_blank">
              <div
                class="tile-image"
                :style="{ 'background-image': 'url('+ image.image_1280 +')' }">
              </div>
            </a>
          </div>
          <div class="tile is-vertical is-4 segment-11">
            <div
              v-for="image in [segment.images[0]]"
              class="tile is-child tx_full_h tx_full_h1">

              <a :href="image.image.path" target="_blank">
                <div
                  class="tile-image"
                  :style="{ 'background-image': 'url('+ image.image_900 +')' }">
                </div>
              </a>
            </div>
            <div
              v-for="image in [segment.images[1]]"
              class="tile is-child tx_full_h tx_full_h1">

              <a :href="image.image.path" target="_blank">
                <div
                  class="tile-image"
                  :style="{ 'background-image': 'url('+ image.image_900 +')' }">
                </div>
              </a>
            </div>
          </div>
          <div
            v-if="segment.selection === 13"
            v-for="image in [segment.images[4]]"
            class="tile is-child is-4 tx_full_h tx_full_h2">

            <a :href="image.image.path" target="_blank">
              <div
                class="tile-image"
                :style="{ 'background-image': 'url('+ image.image_1280 +')' }">
              </div>
            </a>
          </div>
          <div class="tile is-vertical is-4">
            <div
              v-for="image in [segment.images[2]]"
              class="tile is-child tx_full_h tx_full_h1">

              <a :href="image.image.path" target="_blank">
                <div
                  class="tile-image"
                  :style="{ 'background-image': 'url('+ image.image_900 +')' }">
                </div>
              </a>
            </div>
            <div
              v-for="image in [segment.images[3]]"
              class="tile is-child tx_full_h tx_full_h1">

              <a :href="image.image.path" target="_blank">
                <div
                  class="tile-image"
                  :style="{ 'background-image': 'url('+ image.image_900 +')' }">
                </div>
              </a>
            </div>
          </div>
          <div
            v-if="segment.selection === 11"
            v-for="image in [segment.images[4]]"
            class="tile is-child is-4 tx_full_h tx_full_h2">

            <a :href="image.image.path" target="_blank">
              <div
                class="tile-image"
                :style="{ 'background-image': 'url('+ image.image_1280 +')' }">
              </div>
            </a>
          </div>
        </div>

        <div v-else class="tile is-parent">
          <div v-for="image in segment.images"
            class="tile is-child is-4 tx_full_h tx_full_h1">

            <a :href="image.image.path" target="_blank">
              <div
                class="tile-image"
                :style="{ 'background-image': 'url('+ image.image_900 +')' }">
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="control notification is-danger" v-if="error">
        <button class="delete" @click="error = undefined"></button>
        {{ error }}
      </div>
    </div>

    <section-comment></section-comment>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import auth from '@/apis/Auth'
export default {
  data () {
    return {
      error: null,
      images: [],
      segments: []
    }
  },
  computed: mapGetters([
    'evenOrOdd',
    'isAuthenticated'
  ]),
  methods: {
    arraySplice: (curr, num) => {
      var first = []
      var second = []
      if (num > curr.length) {
        num = curr.length
      }
      for (var i = 0; i < curr.length; i++) {
        if (i < num) {
          first.push(curr[i])
        } else {
          second.push(curr[i])
        }
      }
      return {
        curr: curr,
        splice: first,
        remain: second
      }
    },
    updateUI: function (images) {
      this.segments = []
      var variation = 14
      var spliceMap = [
        3, 2, 2,
        3, 3,
        3, 3,
        4, 4, 4, 4,
        5, 5, 5
      ]
      // types of grid:
      //
      // 0,1,2,3,4,5,6
      //
      // 310: ... or .-- or --.  0 // 1 // 2
      // 320: |-- or --|         3 // 4
      //      |--    --|
      // 330: ==. or .==         5 // 6
      //        .    .
      //
      // 7,8,9,10,11,12,13
      //
      // 410: --| or ..|  7 // 8
      //      ..|    __|
      //   or |__ or |..  9 // 10
      //      |..    |__
      // 510: ..| or |..  11 // 12   or .|.  // 13
      //      ..|    |..                .|.
      //
      var failsafe = 100
      // var selection = 0
      var selection = Math.floor((Math.random() * variation)) // first selection
      var selectionSplice = spliceMap[selection]
      console.log('splice=' + selection + ',' + selectionSplice)
      while (images.length > 0 && failsafe > 0) {
        failsafe--
        if (failsafe < 80) {
          console.error('invalid territory')
        }

        var spliced = this.arraySplice(images, selectionSplice)
        if (spliced.splice.length <= 0) {
          break
        }

        this.segments.push({
          selection: selection,
          images: spliced.splice
        })
        images = spliced.remain
        console.log('splice=' + selection + ',' + selectionSplice + ', spliced=' + spliced.splice.length + ' remain=' + spliced.remain.length + ' images=' + images.length)

        selection = Math.floor((Math.random() * variation)) // next selection
        // selection++
        // if (selection >= variation) {
        //   selection = 0
        // }
        selectionSplice = spliceMap[selection]
      }

      // check if last splice is valid type or not
      var segmentLast = this.segments[this.segments.length - 1]
      if (segmentLast.images.length !== spliceMap[segmentLast.selection]) {
        var invalid = true
        for (var i = 0; i < 30; i++) {
          selection = Math.floor((Math.random() * variation)) // next selection
          if (segmentLast.images.length === spliceMap[selection]) {
            console.warn('reassign last splice to ' + selection)
            segmentLast.selection = selection
            invalid = false
            break
          }
        }

        if (invalid) {
          console.error('invalid last splice')
          segmentLast.selection = variation
        }
      }

      if (images.length <= 0) {
        console.log('images spliced correctly')
      }
    },
    refresh: function () {
      auth.gallery()
      .then(data => {
        console.log('get gallery')
        console.log(data)
        this.images = data
        this.updateUI(data)
      })
      .catch(error => {
        console.log('invalid get gallery', error)
        this.error = error.error
      })
    },
    ...mapActions([
      'authenticated',
      'unauthenticated'
    ])
  },
  beforeCreate () {
  },
  created () {
    console.log('created Gallery.vue')
  },
  mounted () {
    console.log('mounted Gallery.vue')
    this.$scrollTo(0)
    this.refresh()
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-layout-gallery {
  padding-top: 60px;
}

.tile-image {
  background-size: cover;
  background-position: center center;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.tile.is-parent {
  padding: 0;
}

// .tile.is-vertical>.tile.is-child.tile-image:not(:last-child) {
//   margin-bottom: 0px !important;
// }

.tile.is-vertical>.tile.is-child.tx_full_h:not(:last-child) {
  margin-bottom: 0px !important;
}

.tx_full_h {

  position: relative;

  &:before {
    content: "";
    display: block;
  }

  &.tx_full_h1:before {
    padding-top: 75%;

    @media screen and (max-width: $tablet) {
      padding-top: 50%;
    }
  }

  &.tx_full_h2:before {
    padding-top: 50%;

    @media screen and (max-width: $tablet) {
      padding-top: 50%;
    }
  }

  &.tx_full_h3:before {
    padding-top: 37.5%;

    @media screen and (max-width: $tablet) {
      padding-top: 50%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// LayoutGallery.vue?2a90dd0a